//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <section class="qr_container">
    <qrcode
      class="go_qr"
      :width="qrWidth"
      :value="qrInfo"
      :color="{ light: '#fff' }"
      @change="qrRendered"
      type="image/png"
    />
    <CheckmarkAnimation
      v-if="startAnimation"
      :analyticsEvent="new AnalyticsEvent('pv web qr scanned', 'pv', 'good')"
    />
  </section>
</template>
<script setup>
import { defineProps, inject } from "vue";
import AnalyticsEvent from "@/../../../common/models/AnalyticsEvent";

import Qrcode from "vue-qrcode";
import CheckmarkAnimation from "@/components/sections/qrScanPages/CheckmarkAnimation.vue";

defineProps({
  qrInfo: { type: String, default: null },
  qrWidth: { type: Number, default: null },
  startAnimation: { type: Boolean, default: false },
});

const api = inject("api");

function qrRendered() {
  api.analytics.log(
    new AnalyticsEvent("pv web qr generation success", "pv", "good")
  );
}
</script>

<style lang="scss" scoped>
.qr_container {
  position: relative;

  .go_checkmark {
    margin-left: -2.5%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .go_qr {
    width: 280px;
    margin-left: -7.5%;

    @include tablet {
      width: 220px;
    }

    @include desktop_small {
      width: 150px;
    }
  }

  .go_code {
    margin-top: -15px;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;

    .go_code_box {
      background: #000;
      color: #fff;
      padding: 5px 10px;
    }
  }
}
</style>
